import { render, staticRenderFns } from "./Oauth-callback.vue?vue&type=template&id=7c847f10"
import script from "./Oauth-callback.vue?vue&type=script&lang=js"
export * from "./Oauth-callback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports